export default "__VITE_ASSET__BEOA1IBI__"